import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setDarkModeEvent = createEvent<boolean>();
const toggleDarkModeEvent = createEvent();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getThemeIsDark())
  .on(setDarkModeEvent, (_, data) => data)
  .on(toggleDarkModeEvent, (prev) => !prev)
  .reset(clearEvent);

$store.watch((isDark) => {
  //change theme
  if (isDark) document.documentElement.className = 'dark';
  else document.documentElement.className = '';

  //save on localStorage
  LocalStorageUtils.setThemeIsDark(isDark);
});

export const $themeStore = {
  store: $store,
  events: {
    setDarkMode: setDarkModeEvent,
    toggleDarkMode: toggleDarkModeEvent,
    clear: clearEvent,
  },
};
